module.exports = __webpack_public_path__ + "img/pdt.12eb7b1b.png";